import React, { MutableRefObject, ReactElement, useEffect, useRef, useState } from 'react';
import RCTooltip from 'rc-tooltip';
import styles from './CommentTooltip.module.scss';

interface IToolTipProps {
  children: ReactElement,
  text: string,
  offset?: number[],
}

export function CommentTooltip({ children, text, offset }: IToolTipProps): ReactElement {
  const [alignOptions, setAlignOptions] = useState({ offset })
  const [placementOptions, setPlacementOptions] = useState('topLeft')
  const ref = useRef() as MutableRefObject<any>


  useEffect(() => {
    window.addEventListener('scroll', setAlign);
    return () => window.removeEventListener('scroll', setAlign);
  }, []);

  const setAlign = () => {
    if (ref) {
      const rootDomNode = ref.current.getRootDomNode()
      const documentHeight = document.body.getBoundingClientRect().height
      const rootDomNodeOffsetTop = rootDomNode.getBoundingClientRect().top

      if (rootDomNodeOffsetTop > documentHeight / 2) {
        setAlignOptions({ offset })
        setPlacementOptions('topLeft')
      } else {
        setPlacementOptions('bottomLeft')
        setAlignOptions({ offset: [offset[0], -offset[1]] })
      }
    }
  }

  return (
    <RCTooltip
      ref={ref}
      trigger={'click'}
      destroyTooltipOnHide
      overlayClassName={styles.overlay}
      placement={placementOptions}
      overlay={<span>{text}</span>}
      align={alignOptions}
      onPopupAlign={setAlign}
    >
      {children}
    </RCTooltip>
  );
}
